import { timestampToDateString } from './convert'
import { coercedIsNaN } from './type'

export const currentYear = (): number => new Date().getFullYear()

export const safeTimestamp = (date: Date | string | number): number =>
  Date.parse(new Date(date).toString())

export const safeDateString = (date: Date | string | number): string =>
  timestampToDateString(safeTimestamp(date))

export const sortDateBy = <T>(fn: (item: T) => Date | string | number) => (
  list: T[],
): T[] => [...list].sort((a, b) => safeTimestamp(fn(a)) - safeTimestamp(fn(b)))

export const getYear = (date: Date): number => date.getFullYear()

export const isValidDate = (val: any): val is Date =>
  val instanceof Date && !coercedIsNaN(val.getTime())

export const daysInFuture = (days: number): Date => {
  const date = new Date()
  date.setDate(date.getDate() + days)
  return date
}

export const getTomorrow = (): Date => daysInFuture(1)
